export function isPresidentOfLia(user) {
  if (!user) return false;

  // The backend only exposes this entitlement when the account is an
  // explicitly authorized superuser and the admin API kill switch is on.
  if (!user.is_superuser || !user.access?.can_access_admin) return false;

  // Local development does not require MFA (ADMIN_REQUIRE_MFA=0). Production
  // keeps the enrollment requirement here in addition to the API's recent
  // MFA-session verification.
  return process.env.NODE_ENV !== "production" || Boolean(user.access?.mfa_enabled);
}

export function isAdminOperator(user) {
  if (!user?.access?.can_access_admin) return false;
  const delegated = Array.isArray(user.access.admin_roles) && user.access.admin_roles.length > 0;
  if (!user.is_superuser && !delegated) return false;
  return process.env.NODE_ENV !== "production" || Boolean(user.access?.mfa_enabled);
}

export function hasAdminCapability(user, capability) {
  if (!isAdminOperator(user)) return false;
  if (user.is_superuser) return true;
  return Array.isArray(user.access?.admin_capabilities)
    && user.access.admin_capabilities.includes(capability);
}
